module.exports = __webpack_public_path__ + "img/public/SiteIcons/question.svg?4ca2d442";